import { type Observable } from 'rxjs';
import type { RbacPermissionsEntity } from './rbac-permissions.model';
import type { RbacPermissionsState } from './rbac-permissions.reducer';

import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';

import * as RbacPermissionsSelectors from './rbac-permissions.selectors';

@Injectable()
export class RbacPermissionsFacade {
    private readonly store = inject<Store<RbacPermissionsState>>(Store);

    public readonly permissions$: Observable<RbacPermissionsEntity> = this.store.select(
        RbacPermissionsSelectors.selectPermissions
    );
}
